export default __webpack_public_path__ + "static/media/HqO-text-dark-offset-blue.0ba2d4f4.png";